// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-avatar[data-v-3cdeaaf2]{width:40px;height:40px;display:flex;justify-content:center;align-items:center;color:#fff;border-radius:50%;font-size:20px;text-transform:uppercase;font-weight:500;background-image:linear-gradient(180deg,hsla(0,0%,100%,.4),hsla(0,0%,100%,0))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
